import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MobileCTA from '../../components/feature/MobileCTA';

const ProjectsPage = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    { id: 1, category: 'interior', title: 'Living Room Transformation', location: 'Portage, MI', description: 'Complete interior painting with custom color selection', image: 'https://public.readdy.ai/ai/img_res/9f8ff96f20ea6ab8c6647cd37789d41f.jpg' },
    { id: 2, category: 'exterior', title: 'Complete Exterior Refresh', location: 'Kalamazoo, MI', description: 'Full house exterior painting including trim and doors', image: 'https://readdy.ai/api/search-image?query=beautiful%20two%20story%20house%20with%20freshly%20painted%20exterior%20in%20soft%20blue%20gray%20color%2C%20white%20trim%2C%20professional%20residential%20painting%2C%20clear%20sky%2C%20well%20maintained%20property%2C%20simple%20clean%20background&width=900&height=700&seq=project-exterior-house-001&orientation=landscape' },
    { id: 3, category: 'cabinet', title: 'Kitchen Cabinet Makeover', location: 'Plainwell, MI', description: 'Cabinet refinishing with durable white finish', image: 'https://readdy.ai/api/search-image?query=bright%20modern%20kitchen%20with%20beautifully%20painted%20white%20cabinets%2C%20professional%20cabinet%20refinishing%2C%20clean%20finish%2C%20stainless%20appliances%2C%20simple%20clean%20background%20showcasing%20cabinet%20transformation&width=800&height=800&seq=project-kitchen-white-001&orientation=squarish' },
    { id: 4, category: 'interior', title: 'Master Bedroom Update', location: 'Otsego, MI', description: 'Peaceful bedroom with custom blue-gray walls', image: 'https://readdy.ai/api/search-image?query=peaceful%20master%20bedroom%20with%20freshly%20painted%20soft%20blue%20walls%2C%20professional%20interior%20painting%2C%20comfortable%20bed%2C%20natural%20lighting%2C%20simple%20clean%20background%20showing%20quality%20paint%20finish&width=700&height=900&seq=project-bedroom-001&orientation=portrait' },
    { id: 5, category: 'fence', title: 'Backyard Fence Staining', location: 'Three Rivers, MI', description: 'Privacy fence restored with rich wood stain', image: 'https://readdy.ai/api/search-image?query=wooden%20privacy%20fence%20freshly%20stained%20in%20rich%20brown%20tone%2C%20professional%20fence%20staining%20work%2C%20residential%20backyard%2C%20green%20grass%2C%20simple%20clean%20background%20highlighting%20fence%20restoration&width=900&height=700&seq=project-fence-brown-001&orientation=landscape' },
    { id: 6, category: 'exterior', title: 'Historic Home Restoration', location: 'Kalamazoo, MI', description: 'Careful restoration of classic craftsman exterior', image: 'https://readdy.ai/api/search-image?query=charming%20historic%20craftsman%20house%20with%20freshly%20painted%20exterior%20in%20classic%20colors%2C%20professional%20restoration%20painting%2C%20detailed%20trim%20work%2C%20simple%20clean%20background%20showing%20quality%20craftsmanship&width=800&height=800&seq=project-historic-001&orientation=squarish' },
    { id: 7, category: 'interior', title: 'Open Concept Dining Area', location: 'Portage, MI', description: 'Warm neutral tones for modern dining space', image: 'https://readdy.ai/api/search-image?query=modern%20open%20concept%20dining%20room%20with%20freshly%20painted%20warm%20beige%20walls%2C%20professional%20interior%20painting%2C%20dining%20table%20and%20chairs%2C%20natural%20light%2C%20simple%20clean%20background&width=700&height=900&seq=project-dining-001&orientation=portrait' },
    { id: 8, category: 'cabinet', title: 'Bathroom Vanity Refinish', location: 'Kalamazoo, MI', description: 'Elegant gray finish for bathroom cabinets', image: 'https://readdy.ai/api/search-image?query=elegant%20bathroom%20with%20refinished%20painted%20vanity%20cabinets%20in%20soft%20gray%2C%20professional%20cabinet%20painting%2C%20modern%20fixtures%2C%20clean%20finish%2C%20simple%20background%20showcasing%20vanity%20transformation&width=700&height=900&seq=project-bathroom-vanity-001&orientation=portrait' },
    { id: 9, category: 'fence', title: 'Deck Staining Project', location: 'Plainwell, MI', description: 'Natural wood tone deck restoration', image: 'https://readdy.ai/api/search-image?query=beautiful%20wooden%20deck%20freshly%20stained%20in%20natural%20wood%20tone%2C%20professional%20deck%20staining%20work%2C%20outdoor%20furniture%2C%20backyard%20setting%2C%20simple%20clean%20background%20showing%20deck%20refinishing%20quality&width=900&height=700&seq=project-deck-natural-001&orientation=landscape' },
    { id: 10, category: 'interior', title: 'Home Office Painting', location: 'Portage, MI', description: 'Professional workspace with calming colors', image: 'https://readdy.ai/api/search-image?query=modern%20home%20office%20with%20freshly%20painted%20sage%20green%20accent%20wall%2C%20professional%20interior%20painting%2C%20desk%20and%20shelving%2C%20natural%20light%2C%20simple%20clean%20background%20showing%20quality%20finish&width=700&height=900&seq=project-office-001&orientation=portrait' },
    { id: 11, category: 'exterior', title: 'Ranch Home Exterior', location: 'Otsego, MI', description: 'Complete exterior refresh with modern colors', image: 'https://readdy.ai/api/search-image?query=beautiful%20ranch%20style%20home%20with%20freshly%20painted%20exterior%20in%20modern%20gray%20tones%2C%20white%20trim%2C%20professional%20residential%20painting%2C%20landscaped%20yard%2C%20simple%20clean%20background&width=900&height=700&seq=project-ranch-001&orientation=landscape' },
    { id: 12, category: 'cabinet', title: 'Two-Tone Kitchen Cabinets', location: 'Kalamazoo, MI', description: 'Modern two-tone cabinet refinishing', image: 'https://readdy.ai/api/search-image?query=stylish%20kitchen%20with%20two%20tone%20painted%20cabinets%20navy%20blue%20lower%20white%20upper%2C%20professional%20cabinet%20refinishing%2C%20modern%20design%2C%20simple%20clean%20background%20showcasing%20cabinet%20work&width=800&height=800&seq=project-twotone-001&orientation=squarish' },
  ];

  const filters = [
    { id: 'all', label: 'All Projects', count: projects.length },
    { id: 'interior', label: 'Interior', count: projects.filter(p => p.category === 'interior').length },
    { id: 'exterior', label: 'Exterior', count: projects.filter(p => p.category === 'exterior').length },
    { id: 'cabinet', label: 'Cabinets', count: projects.filter(p => p.category === 'cabinet').length },
    { id: 'fence', label: 'Decks & Fences', count: projects.filter(p => p.category === 'fence').length },
  ];

  const filteredProjects = activeFilter === 'all' ? projects : projects.filter(p => p.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MobileCTA />

      {/* Hero Section */}
      <section className="pt-28 pb-10 bg-[#1A2B4A]">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-3">Our Work</p>
          <h1 className="text-[44px] lg:text-[52px] font-extrabold text-white mb-4">
            Real Projects from Real Homes
          </h1>
          <p className="text-[17px] text-white/70 max-w-[620px] mx-auto leading-relaxed">
            Actual projects completed for homeowners in Southwest Michigan. We add new photos as we finish each job.
          </p>
        </div>
      </section>

      {/* Filter Bar */}
      <section className="py-4 bg-white sticky top-20 z-30 border-b border-gray-200 shadow-sm">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-2">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-4 py-2 rounded-full font-bold text-[13px] transition-all whitespace-nowrap cursor-pointer ${
                  activeFilter === filter.id
                    ? 'bg-[#1A2B4A] text-white shadow-md'
                    : 'bg-[#F3F1EE] text-[#6B7280] hover:bg-gray-200'
                }`}
              >
                {filter.label}
                <span className="ml-1.5 opacity-70">({filter.count})</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-10 bg-[#F8F7F5]">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="group relative h-[380px] rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent">
                  <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                    <span className="inline-block bg-[#C8A96E] px-2.5 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wider mb-2">
                      {project.category === 'fence' ? 'Deck/Fence' : project.category}
                    </span>
                    <h3 className="text-[17px] font-bold mb-1">{project.title}</h3>
                    <p className="text-[13px] text-white/80 mb-1">{project.description}</p>
                    <p className="text-[12px] text-white/70 flex items-center">
                      <i className="ri-map-pin-line mr-1"></i>
                      {project.location}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {filteredProjects.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-image-line text-5xl text-gray-300 mb-3 block"></i>
              <p className="text-[16px] text-[#6B7280]">No projects found in this category</p>
            </div>
          )}
        </div>
      </section>

      {/* Real Photos Trust Bar */}
      <section className="py-8 bg-[#1A2B4A]">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3">
              <i className="ri-camera-line text-2xl text-[#C8A96E]"></i>
              <p className="text-[15px] font-bold text-white">Real Photos, Real Work</p>
            </div>
            <span className="hidden sm:block text-white/30">|</span>
            <p className="text-[14px] text-white/70">Every photo is from an actual project we completed. More added regularly.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#F8F7F5]">
        <div className="max-w-[700px] mx-auto px-6 text-center">
          <h2 className="text-[30px] lg:text-[36px] font-extrabold text-[#1A2B4A] mb-3">
            Ready for Your Own Project?
          </h2>
          <p className="text-[15px] text-[#6B7280] mb-7">
            Let's talk about your painting needs and create a plan for your home
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="tel:+12695551234"
              className="w-full sm:w-auto bg-[#1A2B4A] text-white px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#2A3B5A] transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-lg"></i>
              Call for Free Estimate
            </a>
            <a
              href="sms:+12695551234"
              className="w-full sm:w-auto bg-white border-2 border-[#1A2B4A] text-[#1A2B4A] px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#1A2B4A] hover:text-white transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line mr-2 text-lg"></i>
              Text Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsPage;
